import styled from 'styled-components';

type LanguageSelectorProps = {
  isActive: boolean;
};

export const LanguagesContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LanguageSelector = styled.div<LanguageSelectorProps>`
  text-transform: uppercase;
  color: ${({ theme }) => theme.COLORS.secondary};
  font-weight: ${({ isActive }) => (isActive ? 'bold' : 'normal')};
  font-size: ${({ theme }) => theme.FONT_SIZES.primary};
  display: flex;
  align-items: center;

  &:before {
    color: ${({ theme }) => theme.COLORS.secondary};
    font-size: ${({ theme }) => theme.FONT_SIZES.large};
    font-weight: normal;
    content: '/';
  }

  &:first-child:before {
    content: none;
  }

  &:hover {
    color: ${({ theme }) => theme.COLORS.primaryMiddle};
    cursor: pointer;
  }
`;

export const LanguageSelectorSignup = styled(LanguageSelector)`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.UI_COLORS.light};
  font-weight: normal !important;

  &:before {
    content: '|';
    margin-left: 0.3rem;
    margin-right: 0.3rem;
  }

  &:hover {
    color: ${({ theme }) => theme.UI_COLORS.light};
  }
`;
